<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green" style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center;">
            <div class="card-icon">
              <md-icon>local_mall</md-icon>
            </div>
            <h4 class="title" style="margin: 0 0 0 10px;">Wingio Products</h4>
          </div>
          <md-button
            class="md-raised md-primary add-product-btn"
            @click="$router.push({ path: 'wingio-product-create' })"
          >
            <md-icon style="font-size: 18px; margin-right: 4px;">add</md-icon>
            ADD PRODUCT
          </md-button>

        </md-card-header>

        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Display Name" md-sort-by="displayName">{{ item.displayName }}</md-table-cell>
                <md-table-cell md-label="Type" md-sort-by="productType">{{ item.productType }}</md-table-cell>
                <md-table-cell md-label="Amount" >
                    <span v-if="item.stripePriceDetail">
                      {{ getCurrencySymbol(item.stripePriceDetail.currency) }} {{ item.stripePriceDetail.unit_amount / 100 }}
                      </span>
                    <span v-else>-</span>
                </md-table-cell>
                <md-table-cell md-label="Created" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>                
                <md-table-cell md-label="Actions">
                    <md-button class="md-just-icon md-info md-simple pr-2" @click="$router.push({ path: 'wingio-product-prices', query: { id: item._id }})">
                        <md-icon>currency_pound</md-icon>
                    </md-button>
                    <md-button class="md-just-icon md-info md-simple pr-2" @click="$router.push({ path: 'wingio-product-shipping-prices', query: { id: item._id }})">
                        <md-icon>local_shipping</md-icon>
                    </md-button>
                    <md-button v-if="item.productType != 'Subscription'" class="md-just-icon md-info md-simple pr-4" @click="$router.push({ path: 'wingio-product-edit', query: { id: item._id }})">
                        <md-icon>edit</md-icon>
                    </md-button>
                    <md-button v-if="item.productType != 'Subscription'" class="md-just-icon md-info md-simple pr-3" @click="$router.push({ path: 'wingio-product-images', query: { id: item._id }})">
                        <md-icon>photo_library</md-icon>
                    </md-button>
                    <md-button v-if="item.productType != 'Subscription'"  class="md-just-icon md-danger md-simple" @click="deleteProduct(item._id)"><md-icon>close</md-icon></md-button>
                </md-table-cell>
            </md-table-row>

          </md-table>
          
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "created_at",
      currentSortOrder: "desc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    getWingioProducts() {
        OrdersDataService.wingioProductsList()
          .then((response) => {
            this.tableData = response.data.data;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    getCurrencySymbol(currency) {
        const map = {
        usd: '$',
        eur: '€',
        gbp: '£',
        inr: '₹',
        jpy: '¥',
        aud: 'A$',
        cad: 'C$',
        cny: '¥',
        krw: '₩',
        };
        return map[currency?.toLowerCase()] || currency.toUpperCase();
    },
    deleteProduct(id) {
      Swal.fire({
        title: "Are you sure?",
        text: `This product will be deleted`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id : id
          };
          OrdersDataService.deleteWingioProduct(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.getWingioProducts();
          
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
        }
      });  
    },
  },
  beforeMount() {
    this.getWingioProducts()
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}

.add-product-btn {
  margin-right: 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
}

</style>
